var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFiRrCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 12,
  fill: "none",
  viewBox: "0 0 16 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#006D2E",
  d: "m14.88.954-9.214 9.212a.667.667 0 0 1-.944 0L1.159 6.6a.667.667 0 0 0-1.09.728.7.7 0 0 0 .146.217l3.564 3.563a2.005 2.005 0 0 0 2.833 0l9.212-9.21a.666.666 0 1 0-.945-.944"
})));
export { SvgFiRrCheck as ReactComponent };
export default __webpack_public_path__ + "533f2ec16ea54bf43a4a9d5316969943.svg";